var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_black_24dp",
    transform: "translate(4.666667, 4.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,12.5066667 C13.4088889,12.5066667 12.88,12.74 12.4755556,13.1055556 L6.93,9.87777778 C6.96888889,9.69888889 7,9.52 7,9.33333333 C7,9.14666667 6.96888889,8.96777778 6.93,8.78888889 L12.4133333,5.59222222 C12.8333333,5.98111111 13.3855556,6.22222222 14,6.22222222 C15.2911111,6.22222222 16.3333333,5.18 16.3333333,3.88888889 C16.3333333,2.59777778 15.2911111,1.55555556 14,1.55555556 C12.7088889,1.55555556 11.6666667,2.59777778 11.6666667,3.88888889 C11.6666667,4.07555556 11.6977778,4.25444444 11.7366667,4.43333333 L6.25333333,7.63 C5.83333333,7.24111111 5.28111111,7 4.66666667,7 C3.37555556,7 2.33333333,8.04222222 2.33333333,9.33333333 C2.33333333,10.6244444 3.37555556,11.6666667 4.66666667,11.6666667 C5.28111111,11.6666667 5.83333333,11.4255556 6.25333333,11.0366667 L11.7911111,14.2722222 C11.7522222,14.4355556 11.7288889,14.6066667 11.7288889,14.7777778 C11.7288889,16.03 12.7477778,17.0488889 14,17.0488889 C15.2522222,17.0488889 16.2711111,16.03 16.2711111,14.7777778 C16.2711111,13.5255556 15.2522222,12.5066667 14,12.5066667 Z",
    id: "\\u8DEF\\u5F84",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTwitter);
export default __webpack_public_path__ + "static/media/share_twitter.1ecb19a2fbbb5c819835a363fa4e2a38.svg";
export { ForwardRef as ReactComponent };